module.exports = __webpack_public_path__ + "img/ic_bedrooms.c56ae076.svg";